import {ApplicationConfig, LOCALE_ID, provideZoneChangeDetection} from '@angular/core';
import {DatePipe, registerLocaleData} from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import {provideHttpClient, withInterceptors, withXhr} from '@angular/common/http';
import {PreloadAllModules, provideRouter, withDisabledInitialNavigation, withEnabledBlockingInitialNavigation, withPreloading} from '@angular/router';
import {provideAnimations} from '@angular/platform-browser/animations';
import {MAT_DIALOG_DATA, MAT_DIALOG_DEFAULT_OPTIONS} from '@angular/material/dialog';
import {provideMomentDateAdapter} from '@angular/material-moment-adapter';
import {provideTranslateService} from '@ngx-translate/core';
import {provideTranslateHttpLoader} from '@ngx-translate/http-loader';
import {buildTimestamp} from '../environments/build-info';
import {routes} from './app.routes';
import {globalHttpInterceptor} from './services/auth/global-http.interceptor';
import {connectionInterceptor} from './services/ui/connection.interceptor';
import {providePostHogErrorHandler} from './services/analytics/posthog-error-handler';
import {httpErrorReportingInterceptor} from './services/analytics/http-error-reporting.interceptor';
import {CostPipe} from './pipes/number/cost.pipe';

registerLocaleData(localeFr);

// Loaded inside an iframe (MSAL's hidden auth frames), the app must not navigate.
const isIframe = window !== window.parent && !window.opener;

export const appConfig: ApplicationConfig = {
	providers: [
		provideZoneChangeDetection(),
		provideRouter(routes,
			withPreloading(PreloadAllModules),
			isIframe ? withDisabledInitialNavigation() : withEnabledBlockingInitialNavigation()),
		provideHttpClient(withXhr(), withInterceptors([globalHttpInterceptor, httpErrorReportingInterceptor, connectionInterceptor])),
		provideAnimations(),
		provideTranslateService({
			fallbackLang: 'en',
			loader: provideTranslateHttpLoader({prefix: './assets/i18n/', suffix: `.json?v=${buildTimestamp}`}),
		}),
		provideMomentDateAdapter(undefined, {useUtc: true}),
		{provide: LOCALE_ID, useValue: 'fr-FR'},
		{provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: {}},
		{provide: MAT_DIALOG_DATA, useValue: {}},
		// Pipes injected as formatters, drawers included (they are created against this injector).
		DatePipe,
		CostPipe,
		providePostHogErrorHandler(),
	],
};
